import { useParams } from 'react-router-dom'
import posthog from 'posthog-js'
import SortPill from 'components/sortPill'
import { TDecidedSort } from 'services/loans'

/**
 * «جدیدترین / قدیمی‌ترین» over the decided requests, by the date the card
 * shows as the decision — not the date the request was filed.
 *
 * Newest first by default. These tabs used to open on the OLDEST decision:
 * they asked the server for `reverse=true`, which it never read, so a manager
 * in 1405 opened «پذیرفته‌شده» on requests from اردیبهشت ۱۴۰۴.
 */
export default function DecidedSort({
    sort,
    onChange,
    tab,
}: {
    sort: TDecidedSort
    onChange: (next: TDecidedSort) => void
    tab: 'accepted' | 'rejected'
}) {
    const { id } = useParams()
    const choose = (next: TDecidedSort) => {
        if (next === sort) return
        onChange(next)
        posthog.capture('loan_demands_sorted', {
            fund_id: id,
            tab,
            sort: next,
        })
    }

    return (
        <div
            role="radiogroup"
            aria-label="ترتیب فهرست"
            className=" flex items-center gap-2 px-1 pt-3"
        >
            <span className=" text-[11px] text-text-muted">
                ترتیب بر اساس تاریخ تصمیم
            </span>
            <SortPill
                checked={sort === 'decided_newest'}
                onChange={() => choose('decided_newest')}
                label="جدیدترین"
            />
            <SortPill
                checked={sort === 'decided_oldest'}
                onChange={() => choose('decided_oldest')}
                label="قدیمی‌ترین"
            />
        </div>
    )
}
